





































import { Component, Prop, Vue, Watch, Inject } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
const root = namespace("root/memberPicker");
@Component({})
export default class ByTags extends Vue {
  @root.Action queryTagList;
  @Prop({ type: Array }) initData;
  @Prop({ type: String, required: true }) id;
  @Prop({ type: String }) label;
  @Prop({ type: Boolean, default: false }) required;
  @Prop({ type: Boolean, default: false }) disabled;
  @Inject() labelWidth;
  @Inject() master;
  tagList = [];
  nameFilter = "";
  total = 0;
  curPageNumber = 1;
  form = {
    tagSeleted: []
  };
  get rules() {
    return this.required
      ? {
          tagSeleted: [
            {
              required: true,
              message: this.$t("Root.MemberPicker.required"),
              trigger: "blur"
            }
          ]
        }
      : {};
  }
  @Watch("initData", { immediate: true })
  watchInitData(data) {
    if (data && data.length > 0) {
      this.form.tagSeleted = [...data];
    }
  }
  mounted() {
    this.registerSelf();
    this.getList();
  }
  // 加载下拉数据
  async getList() {
    let input: any = {
      status: 1
    };
    if (this.nameFilter) {
      input.tagName = this.nameFilter;
    }
    let params = {
      input: input,
      pageInput: {
        pageNum: this.curPageNumber,
        pageSize: 100
      }
    };
    let { total, list } = await this.queryTagList(params);
    this.tagList = [...this.tagList, ...list];
    this.total = total;
  }
  // 关闭下拉且之前有搜索字段时，清空操作
  visibleSelect(val) {
    if (!val && this.nameFilter) {
      this.nameFilter = "";
      this.tagList = [];
      this.getList();
    }
  }
  // 搜索
  searchFn(query) {
    this.nameFilter = query;
    this.tagList = [];
    this.curPageNumber = 1;
    this.getList();
  }
  // 滚动加载
  LoadMore() {
    if (this.total <= this.tagList.length) {
      return;
    }
    this.curPageNumber++;
    this.getList();
  }
  // 向父组件传递自己，方便提交时的验证和返回数据
  registerSelf() {
    const { label, id } = this;
    this.master.registerPlugin({
      label: label || id,
      id,
      validator: this.validator.bind(this)
    });
  }
  // 验证
  validator() {
    return new Promise((resolve, reject) => {
      let $form: any = this.$refs.form;
      $form.validate(valid => {
        if (valid) {
          resolve(this.form.tagSeleted);
        }
      });
    });
  }
}
